import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../../../../environments/environment';
import {IPageHtml5} from './page-html-5.model';
import {createRequestOption} from '../../../shared-libs/util/request-util';
import {ProfileService} from '../../../shared-libs/service/profile.service';
import {KeyValue} from '../landing-page/transactional-email.model';
import {SlugifyUppercasePipe} from '../../../shared-libs/pipe/slugify-uppercase.pipe';

type EntityResponseType = HttpResponse<IPageHtml5>;
type EntityArrayResponseType = HttpResponse<IPageHtml5[]>;

@Injectable({providedIn: 'root'})
export class PageHtml5Service {
  public resourceUrl = environment.SERVER_API_URL + 'services/configurator/api/page-html5';

  constructor(protected http: HttpClient,
              protected profileService: ProfileService,
    protected slugifyUppercasePipe: SlugifyUppercasePipe) {}

  private getHeader(): HttpHeaders{
    let headers = new HttpHeaders();
    headers = headers.set('X-DataStoreID', String(this.profileService.getDatastore()));
    return headers;
  }

  create(pageHtml5: IPageHtml5): Observable<EntityResponseType> {
    return this.http.post<IPageHtml5>(this.resourceUrl, pageHtml5, { observe: 'response', headers: this.getHeader() });
  }

  update(pageHtml5: IPageHtml5): Observable<EntityResponseType> {
    return this.http.put<IPageHtml5>(this.resourceUrl, pageHtml5, { observe: 'response', headers: this.getHeader() });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IPageHtml5>(`${this.resourceUrl}/${id}`, { observe: 'response', headers: this.getHeader() });
  }
  findByCode(code: string): Observable<EntityResponseType> {
    return this.http.get<IPageHtml5>(`${this.resourceUrl}-code/${code}`, { observe: 'response', headers: this.getHeader() });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IPageHtml5[]>(this.resourceUrl, { params: options, observe: 'response', headers: this.getHeader() });
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response', headers: this.getHeader() });
  }

  list(): Observable<KeyValue[]> {
    return this.http.get<KeyValue[]>(`${this.resourceUrl}-code`, { observe: 'body', headers: this.getHeader() });
  }

  buildCode(name: string): string{
    return 'HTML5_' + this.slugifyUppercasePipe.transform(name);
  }
}
